import React, { useState, useCallback } from "react";

import * as firebase from "firebase/app";
import "firebase/firestore";
import Avatar from "react-avatar";

const ModifyProfil = (props) => {
  let valueUserInfo = props.valueUserInfo;

  const [pseudoInput, setPseudoInput] = useState(valueUserInfo.pseudo);
  const [bioInput, setBioInput] = useState(valueUserInfo.bio);

  const formModifySubmit = useCallback(
    (e) => {
      e.preventDefault();
      props.setModifyTrigger(false);

      const db = firebase.firestore();

      db.collection("users")
        .doc(valueUserInfo.id)
        .update({
          pseudo: pseudoInput,
          bio: bioInput,
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });
    },
    [pseudoInput, bioInput, valueUserInfo, props]
  );

  const formModifyCancel = useCallback(
    (e) => {
      e.preventDefault();
      props.setModifyTrigger(false);
    },
    [props]
  );

  return (
    <>
      <Avatar
        className="personnal__avatar"
        name={valueUserInfo.pseudo}
        round="100%"
        bsRole="toggle"
      />
      <form
        className="personnal__formModify"
        onSubmit={(e) => formModifySubmit(e)}
      >
        <label>Pseudo</label>
        <input
          required
          type="text"
          placeholder="Pseudo"
          value={pseudoInput}
          onChange={(e) => setPseudoInput(e.target.value)}
        />

        <label>Bio</label>
        <textarea
          type="text"
          placeholder="Parle nous de toi"
          value={bioInput}
          rows="5"
          onChange={(e) => setBioInput(e.target.value)}
        />

        <div className="personnal__formBtn">
          <button
            type="button"
            onClick={(e) => formModifyCancel(e)}
            className="personnal__formClose"
          >
            Annuler
          </button>
          <button className="personnal__formSave" type="submit">
            Enregister
          </button>
        </div>
      </form>
    </>
  );
};

export default ModifyProfil;
